export default __webpack_public_path__ + "static/ogImage-505cbe733bc8dd404d66357f3eea5a11.png";